import { useEffect } from "react";
import Page from "~/lib/components/views/features";
import { getHelpCentreConfigs } from "~/services/variables.service";
import { searchArticlesBySection } from "~/services/zendesk.service";
import { IArticleProps, ISectionProps } from "~/lib/types/article.type";
import { IHelpCentreProps } from "~/lib/types/variables.type";
import { LoaderFunctionArgs } from "@remix-run/node";
import { i18next } from "~/i18n/i18n.server";
import { MetaFunction, useLoaderData } from "@remix-run/react";
import { getSeoMeta } from "~/lib/utils/seo";
import { HELP_CENTER_CONSTANTS } from "~/lib/utils/const";
import { getTranslationVariable } from "~/lib/utils/helper/getVariableTranslation";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return data
    ? getSeoMeta({
        title: `${HELP_CENTER_CONSTANTS.label} - ${getTranslationVariable(
          data.selectedSubsection?.label,
          data.locale
        )}`,
        description: `${getTranslationVariable(
          data.selectedSubsection?.label,
          data.locale
        )}`,
        url: "https://help.setel.com/",
        image: "/images/meta-image.png",
      })
    : [];
};

export const loader = async ({ request, params }: LoaderFunctionArgs) => {
  const id = params.id?.toString() || "";
  const locale = await i18next.getLocale(request);
  const helpConfig: IHelpCentreProps = await getHelpCentreConfigs();
  const sectionProps = helpConfig.TOPICS?.find(
    (section) => section.sectionId.toString() === id
  );
  const selectedSubsection = sectionProps?.subSections.find(
    (subSection) => subSection.value === params.label?.toString()
  );

  // differ from topics page, in features page we need to get all of the article labels
  const articleLabels = selectedSubsection?.articles?.map((item) => item.value);

  let results: IArticleProps[] | undefined = [];
  try {
    results = await searchArticlesBySection({
      label_names: articleLabels,
      section: id,
      locale: locale,
    });
  } catch {}

  return {
    locale,
    articles: results || [],
    sectionProps: sectionProps,
    selectedSubsection: selectedSubsection,
    id,
    helpCentreConfig: helpConfig,
  };
};

export default function PageLayout() {
  const data = useLoaderData<typeof loader>();

  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  return <Page {...data} />;
}

/**
 * FIXME prerender
 */
// export const getStaticPaths: GetStaticPaths = async (props) => {
//   const helpConfig: IHelpCentreProps = await getHelpCentreConfigs();
//   const paths =
//     helpConfig?.TOPICS?.map((topic) => ({
//       params: { label: topic.topic.toString(), id: topic.sectionId.toString() },
//     })) || [];

//   return {
//     paths,
//     fallback: true,
//   };
// };
